export default "M 11 17 L 13 17 L 13 19 L 11 19 L 11 17 M 11 5 L 13 5 L 13 15 L 11 15";